module.exports = __webpack_public_path__ + "img/q6-opt-b.47d136b7.png";